import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEyeSlash,
  faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import "../styles/Login.style.css";

const VALID_USERNAME = "eau";
const VALID_PASSWORD = "minerale";

const REMEMBER_KEY = "kpi_radar_remember_me";
const SAVED_USER_KEY = "kpi_radar_saved_username";
const SAVED_PASS_KEY = "kpi_radar_saved_password";

interface LoginProps {
  onLogin: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [username, setUsername] = useState(() => {
    return localStorage.getItem(SAVED_USER_KEY) || "";
  });
  const [password, setPassword] = useState(() => {
    return localStorage.getItem(SAVED_PASS_KEY) || "";
  });
  const [rememberMe, setRememberMe] = useState<boolean>(() => {
    return localStorage.getItem(REMEMBER_KEY) === "true";
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    const trimmedUser = username.trim();

    if (!trimmedUser || !password) {
      setError("Please enter your username and password.");
      return;
    }

    if (trimmedUser === VALID_USERNAME && password === VALID_PASSWORD) {
      localStorage.setItem("kpi_radar_auth", "true");
      if (rememberMe) {
        localStorage.setItem(REMEMBER_KEY, "true");
        localStorage.setItem(SAVED_USER_KEY, trimmedUser);
        localStorage.setItem(SAVED_PASS_KEY, password);
      } else {
        localStorage.removeItem(REMEMBER_KEY);
        localStorage.removeItem(SAVED_USER_KEY);
        localStorage.removeItem(SAVED_PASS_KEY);
      }
      onLogin();
    } else {
      setError("Invalid username or password.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>KPI Radar</h1>
          <p>Sign in to access the platform</p>
        </div>

        {error && (
          <div className="login-error" role="alert">
            <FontAwesomeIcon icon={faCircleExclamation} />
            <span>{error}</span>
          </div>
        )}

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="login-username">Username</label>
            <div className="input-wrapper">
              <input
                id="login-username"
                type="text"
                autoComplete="username"
                autoFocus
                placeholder="Enter your username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="login-password">Password</label>
            <div className="input-wrapper">
              <input
                id="login-password"
                type={showPassword ? "text" : "password"}
                autoComplete="current-password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
                title={
                  showPassword
                    ? "Hide password"
                    : "Show password"
                }
                aria-label={
                  showPassword
                    ? "Hide password"
                    : "Show password"
                }
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </button>
            </div>
          </div>

          <div className="login-options">
            <label className="remember-me-label" htmlFor="login-remember">
              <input
                id="login-remember"
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <span>Remember me</span>
            </label>
          </div>

          <button type="submit" className="login-btn">
            Sign In
          </button>
        </form>

        <div className="login-footer">
          <span>KPI Engine Configuration & Monitoring</span>
        </div>
      </div>
    </div>
  );
};

export default Login;
